/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const changeGreetingPriorityModelSchema = z.object({
    "priority": z.number().int().describe("Новый приоритет"),
"id": z.string().uuid().describe("Идентификатор шаблона")
    })